<template>
    <div>
        <div v-if="headers">
            <div :class="[ !isFieldEmpty(sub_name) ? 'fw-500 f-110 border-bottom border-color-gray-300' : '', '']">
                {{ showTranslation(sub_name, sub_name_e, sub_name_c) || sub_name }}
            </div>
            <div :class="[ !isFieldEmpty(sub_description) ? 'mb-3': 'mb-0', '']">

                <!-- sub_info 정보 -->
                <template v-if="!isFieldEmpty(sub_info)">
                    <div v-if="is_visible" :id="`sub_info-${sub_code}`" class="mt-2 mb-3 px-1 blue f-90">
                        <fa icon="info-circle" class="mr-1"></fa>
                        <span v-html="showTranslation(sub_info, sub_info_e, sub_info_c)"></span>
                    </div>
                </template>

                <!-- sub_condition -->
                <div v-if="is_sub_condition_activated==true" :id="`sub_condition-${sub_code}`" class="my-2 py-2">
                    <b-form-checkbox
                        v-model="sub_condition.value"
                        @change="radioSave"
                        :disabled="is_locked || is_disabled_by_parent"
                        > {{ showTranslation(sub_condition.text, sub_condition.text_e, sub_condition.text_c) }}
                    </b-form-checkbox>
                </div>
            </div>
        </div>

        <!-- textbox 유형 Sub Component -->
        <div :class="sub_data_header.bordered == true ? 'bordered-guide-text' : ''"> 
            <!-- html 모드는 번역이 plain text 로 만들어져 태그가 깨질 수 있어 한국어 원문 유지 -->
            <div v-if="sub_data_header.html == true">
                <span v-html="sub_data_contents.structure[0]"></span>
            </div>
            <div v-else> {{ guideBody }} </div>
        </div> 

        <!-- Child Component -->
        <sub-component @update-parent-contents="handleUpdateParentContents" :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" v-for="item in child_subs" :key="item.id" :sub_type="item.sub_type" :item="item"></sub-component>
    </div>
</template>

<script>
import { SubComponentMixin } from '@core_mixins/SubComponentMixin'

export default {
    name: 'df-guide-text',
    mixins: [SubComponentMixin],
    data () {
        return {}
    },
    computed: {
        guideBody() {
            // 번역(structure_ea/ca)이 비면 한국어 원문으로 대체
            const c = this.sub_data_contents
            const first = v => Array.isArray(v) ? v[0] : v
            const translated = this.showTranslation(c.structure[0], first(c.structure_ea), first(c.structure_ca))
            return translated || c.structure[0]
        },
        textarea_rows: {
            get() {
                if(this.sub_data_header?.rows && this.sub_data_header.rows != 0) { 
                    return this.sub_data_header.rows
                } else { 
                    return 8 
                }
            }
        }
    }
}
</script>

<style>
.bordered-guide-text{
    padding: 1rem 1.75rem;
    background-color: var(--gray-200);
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
}
</style>
